import {
   Clock,
   CheckCircle,
   XCircle,
   DollarSign,
   Package,
   Truck,
   CircleCheck,
   Ban,
   BringToFront
} from "lucide-react";

export const ESTADOS_COTIZACION = {
   pendiente: {
      label: "Pendiente",
      color: "bg-yellow-100 text-yellow-800",
      icon: Clock,
      description: "Cotización en espera de respuesta",
      perfil: "usuario",
      order: 1,
   },
   cotizado: {
      label: "Cotizado",
      color: "bg-blue-100 text-blue-800",
      icon: CheckCircle,
      description: "Cotización enviada al cliente",
      perfil: "admin",
      order: 2,
   },
   aceptado: {
      label: "Aceptado",
      color: "bg-green-100 text-green-800",
      icon: CircleCheck,
      description: "Cliente aceptó la cotización",
      perfil: "usuario",
      order: 3,
   },
   pagado: {
      label: "Pagado",
      color: "bg-blue-100 text-blue-800",
      icon: DollarSign,
      description: "Pago recibido del cliente",
      perfil: "admin",
      order: 4,
   },
   procesando: {
      label: "Procesando",
      color: "bg-purple-100 text-purple-800",
      icon: Package,
      description: "Trabajo en proceso de elaboración",
      perfil: "admin",
      order: 5,
   },
   enviado: {
      label: "Enviado",
      color: "bg-green-100 text-green-800",
      icon: Truck,
      description: "Producto enviado al cliente",
      perfil: "admin",
      order: 6,
   },
   entregado: {
      label: "Entregado",
      color: "bg-green-100 text-green-800",
      icon: CheckCircle,
      description: "Producto entregado exitosamente",
      perfil: "admin",
      order: 7,
   },
   terminado: {
      label: "Terminado",
      color: "bg-gray-100 text-gray-800",
      icon: CheckCircle,
      description: "Proceso de elaboración terminado",
      perfil: "admin",
      order: 8,
   },
   anulado: {
      label: "Anulado",
      color: "bg-red-100 text-red-800",
      icon: Ban,
      description: "Cancelado por el usuario",
      perfil: "usuario",
      order: 9,
   },
   cancelado: {
      label: "Cancelado",
      color: "bg-red-100 text-red-800",
      icon: XCircle,
      description: "Cancelado por el administrador",
      perfil: "admin",
      order: 10,
   },
   anticipo: {
      // por el usuario
      label: "Anticipo Pagado",
      color: "bg-blue-100 text-blue-800",
      perfil: "usuario",
      icon: DollarSign,
   },
   finalizado: {
      // por el usuario
      label: "Cotizacion Entregada y terminada",
      color: "bg-blue-100 text-blue-800",
      perfil: "admin",
      icon: BringToFront,
   }
};

// Helper functions
export const getEstadoConfig = (estado) => {
   return (
      ESTADOS_COTIZACION[estado?.toLowerCase()] || ESTADOS_COTIZACION.pendiente
   );
};

export const getEstadosOrdenados = () => {
   return Object.entries(ESTADOS_COTIZACION)
      .sort(([, a], [, b]) => a.order - b.order)
      .reduce((acc, [key, value]) => {
         acc[key] = value;
         return acc;
      }, {});
};

export const getEstadosActivos = () => {
   const estadosExcluidos = ["anulado", "cancelado", "terminado"];
   return Object.entries(ESTADOS_COTIZACION)
      .filter(([key]) => !estadosExcluidos.includes(key))
      .reduce((acc, [key, value]) => {
         acc[key] = value;
         return acc;
      }, {});
};
export const getEstadosxPerfil = (perfil) => {
   return Object.entries(ESTADOS_COTIZACION)
      .filter(([key, value]) => value.perfil === perfil)
      .sort(([, a], [, b]) => a.label - b.label)
      .reduce((acc, [key, value]) => {
         acc[key] = value;
         return acc;
      }, {});
};

export const getEstadosFinalizados = () => {
   const estadosFinalizados = [
      "entregado",
      "terminado",
      "anulado",
      "cancelado",
   ];
   return Object.entries(ESTADOS_COTIZACION)
      .filter(([key]) => estadosFinalizados.includes(key))
      .reduce((acc, [key, value]) => {
         acc[key] = value;
         return acc;
      }, {});
};

export const getEstadosPorCategoria = () => {
   return {
      pendientes: ["pendiente", "cotizado"],
      enProceso: ["aceptado", "pagado", "procesando", "enviado"],
      finalizados: ["entregado", "terminado"],
      cancelados: ["anulado", "cancelado"],
   };
};
